
import { getCustomerList, addCustomer, uploadCustomerFile, getContractList, updateContractNote, getBuyerOrSeller,
  uploadContractFile, addContract, approvalCustomer, updateCustomer, contractOperation, depositTailInvoice, updateContractOperation,
  updateLogistics, addContractDocument } from '@/api/contract'

const contract = {
  state: {
    total: 0,
    rows: [],
    tabs: [],
    row: {},
    fileData: {},
    buyerOrSeller: {},
    datas: {},
    isShow: false
  },
  mutations: {
    SET_TOTAL: (state, total) => {
      state.total = total
    },
    SET_ROWS: (state, rows) => {
      state.rows = rows
    },
    SET_TABS: (state, tabs) => {
      state.tabs = tabs
    },
    SET_ROW: (state, row) => {
      state.row = row
    },
    SET_BUY_SELLER: (state, buyerOrSeller) => {
      state.buyerOrSeller = buyerOrSeller
    },
    SET_FILE_DATA: (state, fileData) => {
      state.fileData = fileData
    },
    SET_DATAS: (state, datas) => {
      state.datas = datas
    },
    SET_ISSHOW: (state, isShow) => {
      state.isShow = isShow
    }
  },
  actions: {
    // 查询客户版块主页面信息
    GetCustomerList({ commit }, params) {
      return new Promise((resolve, reject) => {
        getCustomerList(params).then(response => {
          commit('SET_TOTAL', response.Data.Total)
          commit('SET_ROWS', response.Data.Rows)
          commit('SET_TABS', response.Data.Tabs)
          resolve()
        }).catch(error => {
          reject(error)
        })
      })
    },
    AddCustomer({ commit }, params) {
      return new Promise((resolve, reject) => {
        addCustomer(params).then(() => {
          resolve()
        }).catch(error => {
          reject(error)
        })
      })
    },
    UploadCustomerFile({ commit }, params) {
      return new Promise((resolve, reject) => {
        uploadCustomerFile(params).then((response) => {
          commit('SET_ROWS', response.Data.Datas)
          resolve()
        }).catch(error => {
          reject(error)
        })
      })
    },

    GetContractList({ commit }, params) {
      return new Promise((resolve, reject) => {
        getContractList(params).then((response) => {
          commit('SET_TOTAL', response.Data.Total)
          commit('SET_ROWS', response.Data.Rows)
          resolve()
        }).catch(error => {
          reject(error)
        })
      })
    },
    UpdateCustomer({ commit }, params) {
      return new Promise((resolve, reject) => {
        updateCustomer(params).then((response) => {
          resolve()
        }).catch(error => {
          reject(error)
        })
      })
    },

    // --------------------------------------------------审批板块-------------------------------------------
    // 查询审批版块主页面信息
    ApprovalCustomer({ commit }, params) {
      return new Promise((resolve, reject) => {
        approvalCustomer(params).then((response) => {
          resolve()
        }).catch(error => {
          reject(error)
        })
      })
    },

    // 修改审批版块备注信息
    UpdateContractNote({ commit }, params) {
      return new Promise((resolve, reject) => {
        updateContractNote(params).then(response => {
          resolve()
        }).catch(error => {
          reject(error)
        })
      })
    },
    // 查询审批版块 新建合同的可下拉公司
    GetBuyerOrSeller({ commit }, params) {
      return new Promise((resolve, reject) => {
        getBuyerOrSeller(params).then(response => {
          commit('SET_BUY_SELLER', response.Data.BuyerOrSeller)
          resolve()
        }).catch(error => {
          reject(error)
        })
      })
    },
    // 上传审批版块文件
    UploadContractFile({ commit }, params) {
      return new Promise((resolve, reject) => {
        uploadContractFile(params).then((response) => {
          commit('SET_FILE_DATA', response.Data.FileData)
          resolve()
        }).catch(error => {
          reject(error)
        })
      })
    },
    // 审批版块 新增合同建档
    AddContract({ commit }, params) {
      return new Promise((resolve, reject) => {
        addContract(params).then((response) => {
          resolve()
        }).catch(error => {
          reject(error)
        })
      })
    },
    ContractOperation({ commit }, params) {
      return new Promise((resolve, reject) => {
        contractOperation(params).then(() => {
          resolve()
        }).catch(error => {
          reject(error)
        })
      })
    },
    DepositTailInvoice({ commit }, params) {
      return new Promise((resolve, reject) => {
        depositTailInvoice(params).then(() => {
          resolve()
        }).catch(error => {
          reject(error)
        })
      })
    },
    UpdateContractOperation({ commit }, params) {
      return new Promise((resolve, reject) => {
        updateContractOperation(params).then(() => {
          resolve()
        }).catch(error => {
          reject(error)
        })
      })
    },
    UpdateLogistics({ commit }, params) {
      return new Promise((resolve, reject) => {
        updateLogistics(params).then(() => {
          resolve()
        }).catch(error => {
          reject(error)
        })
      })
    },
    AddContractDocument({ commit }, params) {
      return new Promise((resolve, reject) => {
        addContractDocument(params).then(() => {
          resolve()
        }).catch(error => {
          reject(error)
        })
      })
    }
  }
}
export default contract



// WEBPACK FOOTER //
// ./src/store/modules/contract.js